var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagesTips",style:({ color: _vm.color })},[(_vm.showTitle)?_c('h5',[_c('i',{staticClass:"iconfont iconu268"}),_c('span',[_vm._v("温馨提示")])]):_vm._e(),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }